/*window.dataLayer = window.dataLayer || [];

  function gtag() {
    dataLayer.push(arguments);
  }

  gtag('js', new Date());
  gtag('config', 'UA-115747418-2');
*/

var gaProperty = "UA-115747418-2";
var disableStr = "ga-disable-" + gaProperty;
if (document.cookie.indexOf(disableStr + "=true") > -1) {
  window[disableStr] = true;
}
function gaOptout() {
  document.cookie =
    disableStr + "=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/";
  window[disableStr] = true;
  alert("Das Tracking ist jetzt deaktiviert");
}
(function (i, s, o, g, r, a, m) {
  i["GoogleAnalyticsObject"] = r;
  (i[r] =
    i[r] ||
    function () {
      (i[r].q = i[r].q || []).push(arguments);
    }),
    (i[r].l = 1 * new Date());
  (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m);
})(
  window,
  document,
  "script",
  "https://www.google-analytics.com/analytics.js",
  "ga"
);

ga("create", "UA-115747418-2", "auto");
ga("set", "anonymizeIp", true);
ga("send", "pageview");



//////////////////
// WEBPACK FOOTER
// /agir/src/static/googleAnalyticsScript.js
// module id = ../../../../../src/static/googleAnalyticsScript.js
// module chunks = main